// extracted by mini-css-extract-plugin
export default {"tab":"ProgramLevelSubContant2_tab__0hmEH","pointed_list":"ProgramLevelSubContant2_pointed_list__yZ9Nt"};